// ── Environment ──────────────────────────────────────────────────
export const isProd = true;
export const BASE_URL = isProd
  ? "https://prod.rashailagro.in"
  : "http://127.0.0.1:8000";

// ── FPO Auth ─────────────────────────────────────────────────────
export const fpoLoginUrl = `${BASE_URL}/fpo/login/`;

// ── FPO Profile ──────────────────────────────────────────────────
export const fpoProfileUrl = `${BASE_URL}/fpo/profile/`;

// ── FPO Staff ────────────────────────────────────────────────────
export const fpoStaffUrl = `${BASE_URL}/fpo/staff/`;
export const fpoStaffDetailUrl = (id) => `${BASE_URL}/fpo/staff/${id}/`;
export const fpoStaffSetPasswordUrl = (id) => `${BASE_URL}/fpo/staff/${id}/set-password/`;

// ── FPO Commodities ──────────────────────────────────────────────
export const fpoCommoditiesUrl = `${BASE_URL}/fpo/commodities/`;
export const fpoCommodityDetailUrl = (id) => `${BASE_URL}/fpo/commodities/${id}/`;
export const fpoCommodityDropdownUrl = `${BASE_URL}/fpo/commodities/dropdown/`;

// ── FPO Members ──────────────────────────────────────────────────
export const fpoMembersUrl = `${BASE_URL}/fpo/members/`;
export const fpoMemberLocationsUrl = `${BASE_URL}/fpo/members/locations/`;

// ── FPO Locations ────────────────────────────────────────────────
export const fpoStatesUrl = `${BASE_URL}/fpo/states/`;
export const fpoDistrictsUrl = `${BASE_URL}/fpo/districts/`;

// ── FPO Notification Templates ─────────────────────────────────────
export const fpoTemplatesUrl = `${BASE_URL}/fpo/templates/`;
export const fpoTemplateDetailUrl = (id) => `${BASE_URL}/fpo/templates/${id}/`;

// ── FPO Broadcasts ───────────────────────────────────────────────
export const fpoBroadcastsUrl = `${BASE_URL}/fpo/broadcasts/`;
export const fpoBroadcastDetailUrl = (id) => `${BASE_URL}/fpo/broadcasts/${id}/`;
export const fpoBroadcastRecipientsUrl = (id) => `${BASE_URL}/fpo/broadcasts/${id}/recipients/`;

// ── Procurement – Warehouses ──────────────────────────────────────
export const fpoWarehousesUrl = `${BASE_URL}/fpo/warehouses/`;
export const fpoWarehouseDetailUrl = (id) => `${BASE_URL}/fpo/warehouses/${id}/`;

// ── Procurement ──────────────────────────────────────────────────
export const fpoProcurementsUrl = `${BASE_URL}/fpo/procurements/`;
export const fpoProcurementDetailUrl = (id) => `${BASE_URL}/fpo/procurements/${id}/`;
export const fpoProcurementApproveUrl = (id) => `${BASE_URL}/fpo/procurements/${id}/approve/`;
export const fpoProcurementRejectUrl = (id) => `${BASE_URL}/fpo/procurements/${id}/reject/`;
export const fpoProcurementCorrectUrl = (id) => `${BASE_URL}/fpo/procurements/${id}/correct/`;
export const fpoProcurementBulkApproveUrl = `${BASE_URL}/fpo/procurements/bulk-approve/`;
export const fpoProcurementSummaryUrl = `${BASE_URL}/fpo/procurements/summary/`;

// ── Stock ────────────────────────────────────────────────────────
export const fpoStockBatchesUrl = `${BASE_URL}/fpo/stock/batches/`;
export const fpoStockMovementsUrl = `${BASE_URL}/fpo/stock/movements/`;
export const fpoStockSummaryUrl = `${BASE_URL}/fpo/stock/summary/`;

// ── Farmer Payments ──────────────────────────────────────────────
export const fpoFarmerPaymentsUrl = `${BASE_URL}/fpo/farmer-payments/`;

// ── Farmer Ledger ────────────────────────────────────────────────
export const fpoLedgerFarmersUrl = `${BASE_URL}/fpo/ledger/farmers/`;
export const fpoLedgerFarmerDetailUrl = (id) => `${BASE_URL}/fpo/ledger/farmers/${id}/`;
export const fpoLedgerManualAdjustmentUrl = (id) => `${BASE_URL}/fpo/ledger/farmers/${id}/manual-adjustment/`;

// ── Asset Register ────────────────────────────────────────────────
export const fpoAssetsUrl = `${BASE_URL}/fpo/assets/`;
export const fpoAssetDetailUrl = (id) => `${BASE_URL}/fpo/assets/${id}/`;
export const fpoAssetSummaryUrl = `${BASE_URL}/fpo/assets/summary/`;
export const fpoAssetLookupsUrl = `${BASE_URL}/fpo/assets/lookups/`;
